import { deliveryRateOf } from '../dashboard/performance.ts';
import type { DeliveryReport } from './statistics.ts';

export type GovernorateFigures = DeliveryReport['governorates'][number];

export type RankedGovernorate = GovernorateFigures & {
  readonly rate: number | null;
  readonly rank: number | null;
};

const HEAT_LIMITS = [0.65, 0.72, 0.8, 0.87] as const;

export const HEAT_STEPS = 5;

export const heatOf = (rate: number | null): number | null => {
  if (rate === null) return null;
  const below = HEAT_LIMITS.findIndex((limit) => rate < limit);
  return below === -1 ? HEAT_STEPS : below + 1;
};

const byRateThenParcels = (left: RankedGovernorate, right: RankedGovernorate): number =>
  (right.rate ?? -1) - (left.rate ?? -1) || right.parcels - left.parcels;

export const rankedGovernoratesOf = (
  governorates: readonly GovernorateFigures[],
): readonly RankedGovernorate[] =>
  governorates
    .map((governorate) => ({ ...governorate, rate: deliveryRateOf(governorate), rank: null }))
    .toSorted(byRateThenParcels)
    .map((governorate, index) =>
      governorate.rate === null ? governorate : { ...governorate, rank: index + 1 },
    );

const ACCENTS = /[̀-ͯ]/gu;

export const foldedName = (name: string): string => name.normalize('NFD').replace(ACCENTS, '').toLowerCase();
